var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.$route.name !== 'Login' && _vm.$route.name !== 'SSOLogin' && _vm.$route.name !== 'ComeIn'))?_c('v-app',[_c('default-bar'),_c('default-drawer'),_c('default-view'),_c('default-settings')],1):_c('v-app',[_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }